module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat3@2x-ac63a2e51e1f2bae595a0834013187d7.jpg";